import { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  Tabs,
  Tab,
  Paper,
  useTheme,
  useMediaQuery,
  Autocomplete,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  InputAdornment,
  IconButton,
  CircularProgress,
  Modal,
  Slide,
  Alert,
} from "@mui/material";
import "../../../../css/medint.css";
import doctorImage from "../../../../assets/Avatar=Medico 1.svg";
import { Helmet } from "react-helmet-async";
import MedintBookings from "./Bookings/MedintBookings";
import { useNavigate } from "react-router-dom";
import { Controller, FormProvider, UseFormReturn } from "react-hook-form";
import { useFormMedint } from "../MedintUseFormContext/formContext";
import { MedintDataContext } from "../../Context/MedintContextWrapper";
import searchIcon from "../../../../assets/icons/SearchFilled.svg";
import MedintFormInterface, {
  FormattedMednotDataObject,
  FormattedUnitaErogatriciDataObject,
} from "../../../../services/medintInterfaces";
import {
  CommonFieldsData,
  generalResearch,
  mediciAge,
  mednot,
  patientResearch,
  referti,
} from "../../../../networking";
import MedintBoxModal from "./MedintBox/MedintBox";
import { StampaAgendaModale } from "../../../AppointmentResearch/AppointmentListDetail/AppointmentListDetail";
import PercentIcon from "@mui/icons-material/Percent";
import {
  RHFCheckbox,
  RHFDateTimePicker,
  RHFTextField,
} from "../../../RHFComponents/RHFComponents";
import MedintAgendaFormDetail from "./Bookings/Agenda/MedintAgendaForm/MedintAgendaFormDetail";
import FormRicoveri from "./Bookings/Ricoveri/FormRicoveri";
import FormFatturazione from "./Bookings/Fatturazione/FormFatturazione";

export function AllertMessage(props: {
  showAllert: boolean;
  dataToSend?: any;
  showSummary?: Function;
  setShowAllert: (value: boolean) => void;
  submitFunction?: ((value: any) => void) | null;
  message: string;
  severity: any;
}) {
  return (
    <Modal open={props.showAllert}>
      <Slide in={props.showAllert} direction="down" timeout={800}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
            "& .MuiPaper-root": {
              paddingRight: 5,
              paddingLeft: 5,
            },
          }}
        >
          <Alert
            severity={props.severity || "error"}
            action={
              props.submitFunction && props.severity === "warning" ? (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant="containedError"
                    size="small"
                    onClick={() => {
                      props.setShowAllert(false);
                    }}
                  >
                    Uscita
                  </Button>
                  <Button
                    variant="containedCustom"
                    size="small"
                    onClick={() => {
                      if (props.submitFunction) {
                        props.submitFunction(props?.dataToSend);
                      }
                    }}
                  >
                    Conferma
                  </Button>
                </Box>
              ) : props.submitFunction &&
                props.showSummary &&
                props.severity === "success" ? (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant="containedCustom"
                    size="small"
                    onClick={() => {
                      if (props.showSummary) {
                        props.showSummary();
                      }
                    }}
                  >
                    Dettaglio
                  </Button>
                </Box>
              ) : (
                ""
              )
            }
            sx={{
              maxWidth: "150vh",
              width: "90%",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              transform: "translate3d(20%, 100%, 0%)",
              flexDirection: "row",
              "& .MuiAlert-icon": {
                fontSize: 30,
              },
            }}
          >
            <Typography
              component="div"
              marginTop={"20px"}
              marginLeft={"20px"}
              marginRight={"10px"}
              marginBottom={"20px"}
              fontSize={"20px"}
              fontStyle={"capitalize"}
            >
              {props.message}
            </Typography>
          </Alert>
        </Box>
      </Slide>
    </Modal>
  );
}

export function NoteAggiuntiveModale(props: {
  methods: UseFormReturn<any>;
  showModaleNoteAggiuntive: boolean;
  allertMessageProps: {
    showAllert: boolean;
    setShowAllert: React.Dispatch<React.SetStateAction<boolean>>;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
    setSeverity: React.Dispatch<React.SetStateAction<string>>;
    severity: string;
    message: string;
    dataToSend: any;
    setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  };
  setShowModaleNoteAggiuntive: (value: boolean) => void;
}) {
  const context = useContext(MedintDataContext);

  const handleSubmitNote = async () => {
    try {
      const payload = {
        crud: "u",
        medint_prgint: context?.selectedDoctor.pkey,
        aziendaPrenotazione: "",
        dati: {
          mednot: {
            MEDINT_PRGINT: context?.selectedDoctor.pkey,
            MEDNOT_NOTE: props.methods.getValues("noteAggiuntive"),
          },
        },
      };

      const response = await mednot(payload);

      props.allertMessageProps.setShowAllert(true);

      if (response.data.esito === "OK") {
        props.allertMessageProps.setMessage(response.data.messaggio);
        props.allertMessageProps.setSeverity("success");
      } else {
        props.allertMessageProps.setMessage(
          "Errore sulla cancellazione dell'agenda",
        );
        props.allertMessageProps.setSeverity("error");
      }
    } catch (error) {
      console.error("Errore sulla send di cancellazione agenda", error);
    } finally {
      props.allertMessageProps.setFn(null);
      setTimeout(() => {
        props.allertMessageProps.setShowAllert(false);
        props.setShowModaleNoteAggiuntive(false);
      }, 5000);
    }
  };

  return (
    <Modal open={props.showModaleNoteAggiuntive}>
      <FormProvider {...props.methods}>
        <Box
          sx={{
            maxHeight: "90vh",
            maxWidth: "150vh",
            width: "50%",
            overflow: "auto",
            paddingTop: 1,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Tabs value={0} sx={{ paddingLeft: 2 }}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Note Aggiuntive"
            ></Tab>
          </Tabs>
          <Grid container spacing={2} padding={2}>
            <Grid item xs={12} md={12}>
              <RHFTextField
                fullWidth
                placeholder="Inserire il testo.."
                name="noteAggiuntive"
                control={props.methods.control}
                multiline
                rows={6}
                required
                inputProps={{ maxLength: 400 }}
                helperText={
                  (props.methods.watch("noteAggiuntive")?.length ?? 0) + "/400"
                }
              />
            </Grid>
            <Grid item xs={12} md={12} width={"100%"}>
              <Grid container display={"flex"} justifyContent={"space-between"}>
                <Grid item>
                  <Button
                    variant="outlinedError"
                    onClick={() => props.setShowModaleNoteAggiuntive(false)}
                  >
                    Uscita
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="containedCustom"
                    onClick={() => handleSubmitNote()}
                  >
                    Conferma
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
    </Modal>
  );
}

const MedintDetails = () => {
  let mediciAgeController: AbortController | null = null;

  const theme = useTheme();
  const navigate = useNavigate();
  const methods = useFormMedint();
  const context = useContext(MedintDataContext);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [disabled, setDisabled] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [showAllert, setShowAllert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<string>("error");
  const [message, setMessage] = useState<string>("Testo di default");
  const [dataToSend, setDataToSend] = useState<any>(null);

  const [listaSpecialita, setListaSpecialita] = useState<any[]>([]);
  const [listaCodiciRefertiPersonali, setListaCodiciRefertiPersonali] =
    useState<any[]>([]);
  const [listaPagamentiOnorari, setListaPagamentiOnorari] = useState<any[]>([]);
  const [listaMansioni, setListaMansioni] = useState<any[]>([]);
  const [listaPazienti, setListaPazienti] = useState<any[]>([]);
  const [dataLoadMedico, setDataLoadMedico] = useState<boolean>(false);
  const [dataFound, setDataFound] = useState<boolean>(true);
  const [dataLoad, setDataLoad] = useState<boolean>(false);

  const [crudOperation, setCrudOperation] = useState<string>("u");

  const [selectedAnagrafica, setSelectedAnagrafica] = useState<any>();

  const [openBoxModal, setOpenBoxModal] = useState(false);
  const [showModaleStampaAgenda, setShowModaleStampaAgenda] = useState(false);
  const [showModaleNoteAggiuntive, setShowModaleNoteAggiuntive] =
    useState(false);
  //Stato per nascondere i tab dettaglio e prenotazioni quando clicchiamo Inserimento dentro MedintBooking
  const [hideDetailsActions, setHideDetailsActions] = useState(false);

  //State per la definizione di quale funzione richiamare alla submit della conferma sugli alert di cancellazione
  const [fn, setFn] = useState<(() => void) | null>(null);

  // Con AuthGuard, l'utente e' gia' autenticato quando raggiunge questa pagina

  // effect per inizializzare tutte le liste che presenti sui moduli del medico interno
  useEffect(() => {
    context?.requestSpecialitiesListSPECIALITA();
    context?.requestTypologiesTIPOLOGIA();
    context?.requestPerformancePRESTAZIONI();
    context?.requestPerformanceANAPRE();
    context?.requestDettagliNotePANOTET();
    context?.requestRaggruppamentoStampaPARAGGR();
    context?.requestRaggruppamentoRAGGGP();
    context?.requestCodiciProgramma();
    context?.requestEquipeEQUMED();
    context?.requestMansioni();
  }, []);

  // inizializzazione e call request per gestire invocazione del medico selezionato oppure no
  useEffect(() => {
    if (!context?.selectedDoctor) {
      setCrudOperation("c");
      fetchDataTipiSpecializzazioni();
      fetchDataCodiciReferti();
      methods.reset({ medIntDettaglio: { specializzazione: "" } });
      console.warn("Nessun medico selezionato o pkey mancante");
      return;
    }
    console.log(context?.selectedDoctor);
    setDisabled(true);
    fetchDataMedico();
  }, [context?.selectedDoctor]);

  const sendDataMedico = async (data: MedintFormInterface) => {
    if (mediciAgeController) {
      mediciAgeController.abort();
    }
    mediciAgeController = new AbortController();

    try {
      const temp = {
        idMedint: crudOperation === "c" ? "" : context?.selectedDoctor.pkey,
        crud: crudOperation,
        idBac:
          selectedAnagrafica?.IDPAZIENTE ||
          context?.doctorAgenda.medico[0].IDBAC ||
          "",
        // potrebbe tornare utile un controllo su tutti i codici medici presenti?
        codiceMedico: data.medIntDettaglio?.codice ?? "",
        cognomeMedico:
          selectedAnagrafica?.COGNOME ||
          context?.doctorAgenda.medico[0].COGNOMEMEDICO ||
          "",
        nomeMedico:
          selectedAnagrafica?.NOME ||
          context?.doctorAgenda.medico[0].NOMEMEDICO ||
          "",
        cfIntegrazioniMedico: data.medIntDettaglio?.cfIntegrazioniMedico ?? "",
        validitaAgenda:
          data.medIntDettaglio?.validitaAgenda !== "9999-12-31" &&
          data.medIntDettaglio?.validitaAgenda
            ? data.medIntDettaglio?.validitaAgenda
            : "9999-12-31",
        settimaneValiditaAgenda: "0",
        dataFineValiditaMedico:
          data.medIntDettaglio?.dataScadenza !== "9999-12-31" &&
          data.medIntDettaglio?.dataScadenza
            ? data.medIntDettaglio?.dataScadenza
            : "9999-12-31",
        noteMedicoRid: "",
        noteMedicoEst: data.medIntDettaglio?.noteMedico ?? "",
        nominRidottoMedico: data.medIntDettaglio?.nominativoRidotto ?? "",
        codiceReferto: data.medIntDettaglio?.codiceRefertoPersonale ?? "",
        raggruppamentoStampaMedico:
          data.medIntDettaglio?.raggruppamentoStampaMedico ?? "",
        raggruppamentoOrdineMedico: "0",
        abPlanning: data.medIntDettaglio?.planning ? "S" : "", // da testare
        tipoGestione: data.medIntDettaglio?.tipoServizio ?? "T",
        codFRSDO: data.medIntDettaglio?.frsdo ?? "",
        specializzazione: data.medIntDettaglio?.specializzazione ?? "",
        mansione: data.medIntDettaglio?.mansione ?? "",
        pagamentoOnorario: data.medIntDettaglio?.pagamentoOnorario ?? "",
        ritAcconto: data.medIntDettaglio?.ritenutaAcconto ?? "0", // render simbolo percentuale
        flagEquipe: data.medIntDettaglio?.equipe === true ? "S" : "N",
        unErogPrincipale: data.medIntDettaglio?.unitErogPrin ?? "",
        bancaAppoggio: data.medIntDettaglio?.bancaAppoggio ?? "",
        siglaIban: data.medIntDettaglio?.coordBanc?.siglaIban ?? "",
        ctrIban: data.medIntDettaglio?.coordBanc?.ctrIban ?? "",
        codiceCin: data.medIntDettaglio?.coordBanc?.codiceCin ?? "",
        contoCorrente: data.medIntDettaglio?.coordBanc?.contoCorrente ?? "",
        codiceVisitaXIntervento: data.medIntDettaglio?.codVisInterv ?? "",
        codiceEsecutoreXIntervento: data.medIntDettaglio?.codEsecInterv ?? "",
        abProcCollaboratori: data.medIntDettaglio?.abProcCollaboratori ?? "",
        suffissoDocumenti: data.medIntDettaglio?.suffissoDocumenti ?? "",
        contrPrevidenziale: data.medIntDettaglio?.contrPrevidenziale ?? "",
        filialeContabile: data.medIntDettaglio?.filialeContabile ?? "",
        codiceIva: data.medIntDettaglio?.codIva ?? "",
        titoloDoc: data.medIntDettaglio?.titoloDoc ?? "",
        codiceStruttura730: data.medIntDettaglio?.codiceStruttura ?? "",
        voceSaldo: data.medIntDettaglio?.voceSaldo ?? "",

        // CHECKBOX
        abIncTerzi: data.medIntDettaglio?.abIncTerz === true ? "1" : "0",
        numerazioneManuale:
          data.medIntDettaglio?.numerazioneManuale === true ? "1" : "0",
        intResidenzaFiscale:
          data.medIntDettaglio?.intestazioneDoc === true ? "1" : "0",
        swFattElettronica:
          data.medIntDettaglio?.swFattElettronica === true ? "1" : "0",
      };

      const response = await mediciAge(temp, mediciAgeController.signal);

      if (response.data.esito === "KO" || !response.data.esito) {
        setMessage(response.data.messaggio);
        setSeverity("error");
      }

      if (response.data.esito === "OK") {
        setMessage(response.data.messaggio);
        setSeverity("success");
      }
      setShowAllert(true);
      setTimeout(() => {
        setShowAllert(false);
        if (crudOperation === "c" && response.data.esito === "OK") {
          navigate(`/listinoMedici`);
        }
      }, 5000);
    } catch (error) {
      console.error("Errore nella send del medico:", error);
    }
  };

  // funzione fetch che valorizza un medico se selezionato
  const fetchDataMedico = async () => {
    setDataLoadMedico(true);
    try {
      const response = await mediciAge({
        idMedico: context?.selectedDoctor.pkey,
        crud: "r",
      });

      const tempNota = await context?.requestNoteAggiuntiveMedico({
        crud: "r",
        medintPrgInt: context?.selectedDoctor.pkey,
      });

      console.log("Dati medico:", response);

      context?.setDoctorAgenda({
        medico: response.data.dati.medico,
        prestazioni: response.data.dati.prestazioni,
        agende: response.data.dati.agende,
        nondisponibilita: response.data.dati.nondisponibilita,
      });

      const medico = response.data.dati.medico[0];

      const tempListaCodiciTipologieSpecializzazioni =
        response.data.ricerche.tipspl;

      const tempListaPagamentiOnorari = response.data.ricerche.tippag;

      const tempListaMansioni = response.data.ricerche.tipman;

      const tempListaCodiciRefertiDocumenti =
        response.data.ricerche.documenti.filter(
          (e: { ID: string; DESCR?: string }) =>
            e.DESCR?.toLowerCase().includes(`referto`.toLowerCase()),
        );

      const tempListaUnitaErogatrici: FormattedUnitaErogatriciDataObject[] =
        response.data.ricerche.unerog.map((e: any, index: number) => {
          return {
            id: index,
            codUnErog: e.CODUNEROG,
            dataFin: e.DATAFINEVAL,
            dataIni: e.DATAINIVAL,
            desUnErog: e.DESUNEROG,
          };
        });

      const tempListaBanche = response.data.ricerche.banche.map(
        (e: any, index: number) => {
          return {
            id: index,
            codBanche: e.CODBANCHE ?? "N/a",
            desBanche: e.DESBANCHE ?? "N/a",
            ABI: e.ABI ?? "N/a",
            CAB: e.CAB ?? "N/a",
          };
        },
      );

      const tempListaCodIva = response.data.ricerche.codiva.map(
        (e: any, index: number) => {
          return {
            id: index,
            codCodIva: e.CODCODIVA ?? "N/a",
            dataIni: e.DATAINIVAL ?? "N/a",
            dataFin: e.DATAFINEVAL ?? "N/a",
            descodIva: e.DESCODIVA ?? "N/a",
          };
        },
      );

      const tempListaEquipe = response.data.dati.mediciEquipe.map(
        (e: any, index: number) => {
          return {
            id: index,
            idEquMed: e.IDEQUMED ?? "N/a",
            codMedInt: e.CODMEDINT ?? "N/a",
            codMansio: e.CODMANSIO ?? "N/a",
            desMansio: e.DESMANSIO ?? "N/a",
            nominMedint: e.NOMINMEDINT ?? "N/a",
          };
        },
      );

      const tempListaSaldoCollaboratori = response.data.ricerche.vocadd.map(
        (e: any, index: number) => {
          return {
            id: index,
            codVocAdd: e.CODVOCADD ?? "N/a",
            desVocAdd: e.DESVOCADD ?? "N/a",
          };
        },
      );

      setListaCodiciRefertiPersonali(tempListaCodiciRefertiDocumenti);
      setListaSpecialita(tempListaCodiciTipologieSpecializzazioni);
      setListaPagamentiOnorari(tempListaPagamentiOnorari);
      setListaMansioni(tempListaMansioni);
      context?.setListaUnitaErogatrici(tempListaUnitaErogatrici);
      context?.setListaBanche(tempListaBanche);
      context?.setListaCodIva(tempListaCodIva);
      context?.setListaSaldoCollaboratori(tempListaSaldoCollaboratori);

      methods.reset({
        medIntRicoveriInterventi: {
          equipe: tempListaEquipe,
          modalFormValues: {
            medIntCod: medico.CODICEMEDICO,
          },
        },
        noteAggiuntive: tempNota,
        medIntDettaglio: {
          codice: medico.CODICEMEDICO,
          angraficaMedici: `${medico.COGNOMEMEDICO} ${medico.NOMEMEDICO}`,
          nominativoRidotto: medico.NOMINRIDOTTOMEDICO,
          cfIntegrazioniMedico:
            medico.CFINTEGRAZIONIMEDICO ?? "Non disponibile",
          codiceRefertoPersonale: medico.CODICEREFERTO ?? "",
          dataScadenza: medico.DATAFINEVALIDITAMEDICO,
          validitaAgenda: medico.VALIDITAAGENDA,
          settimaneValidita: medico.SETTIMANEVALIDITAAGENDA,
          ritenutaAcconto: medico.RITACCONTO,
          equipe: medico.FLAGEQUIPE === "S" ? true : false,
          planning: medico.ABPLANNING === "" ? false : true,
          frsdo: medico.CODFRSDO ?? "",
          mansione: medico.MANSIONE ?? "",
          pagamentoOnorario: medico.PAGAMENTOONORARIO ?? "",
          specializzazione: medico.SPECIALIZZAZIONE ?? "",
          tipoServizio: "T",
          noteMedico: medico.NOTEMEDICO ?? "",
          raggruppamentoStampaMedico: medico.CODRAGGRSTAMPAMEDICO ?? null,
          codEsecInterv: medico.CODICEESECUTOREXINTERVENTO ?? "",
          codVisInterv: medico.CODICEVISITAXINTERVENTO ?? "",
          unitErogPrin: medico.UNEROGPRINCIPALE ?? "",

          // MAPPING DELLA FATTURAZIONE
          abProcCollaboratori: medico.ABPROCCOLLABORATORI ?? "",

          // CHECKBOXES
          abIncTerz: medico.ABINCTERZI === "0" ? false : true,
          numerazioneManuale: medico.NUMERAZIONEMANUALE === "0" ? false : true,
          swFattElettronica: medico.SWFATTELETTRONICA === "0" ? false : true,
          intestazioneDoc: medico.INTRESIDENZAFISCALE === "0" ? false : true,

          suffissoDocumenti: medico.SUFFISSODOCUMENTI ?? "",
          contrPrevidenziale: medico.CONTRPREVIDENZIALE ?? "",
          filialeContabile: medico.FILIALECONTABILE ?? "",

          codIva: medico.CODICEIVA ?? "",
          titoloDoc: medico.TITOLODOC ?? "",
          codiceStruttura: medico.CODICESTRUTTURA730 ?? "",
          voceSaldo: medico.VOCESALDO ?? "",
          bancaAppoggio: medico.BANCAAPPOGGIO ?? "",

          // IBAN FIELDS
          coordBanc: {
            siglaIban: medico.SIGLAIBAN ?? "",
            ctrIban: medico.CTRIBAN ?? "",
            codiceCin: medico.CODICECIN ?? "",
            banchxabi: medico.BANCHXABI ?? "",
            banchxcab: medico.BANCHXCAB ?? "",
            contoCorrente: medico.CONTOCORRENTE ?? "",
          },
        },
      });
    } catch (error) {
      console.error("Errore nella fetch del medico:", error);
    } finally {
      setDataLoadMedico(false);
    }
  };

  // funzione fetch che valorizza la select dropdown dei codici di tipologie selezionabili
  const fetchDataTipiSpecializzazioni = async () => {
    try {
      const response = await generalResearch({
        tabella: "TIPSPL",
        codice: "",
        filtro: "",
        applicazione: "TIPSPL",
        attivi: "9",
      });
      const specialitaList = response.data.dati;

      console.log({ specialitaList });

      setListaSpecialita(specialitaList);
    } catch (error) {
      console.error("Error fetching RICERCHE specialita:", error);
    }
  };

  // funzione fetch che valorizza la select dropdown dei codici dei referti selezionabili
  async function fetchDataCodiciReferti() {
    const objectJsonRequest: CommonFieldsData = {
      codice: "",
      tipodoc: "LS",
    };

    try {
      const refertiResponse = await referti(objectJsonRequest);
      const tempReferti = refertiResponse.data.dati.filter(
        (e: { ID: string; DESCR?: string }) =>
          e.DESCR?.toLowerCase().includes(`referto`.toLowerCase()),
      );

      setListaCodiciRefertiPersonali(tempReferti);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  //Cambia lo stato selectedTab da 0 a 1 in base alla Tab selezionata dall'utente
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleExitClick = () => {
    localStorage.removeItem("Dottore selezionato");
    navigate(`/listinoMedici`);
  };

  if (isMobile) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h6" sx={{ textAlign: "center", mt: 4 }}>
          📲 Questa funzionalità non è disponibile su smartphone.
        </Typography>
        <Typography sx={{ textAlign: "center", mt: 2 }}>
          Accedi da un dispositivo con uno schermo più grande per visualizzare
          la pagina.
        </Typography>
      </Box>
    );
  }

  const onSubmit = methods.handleSubmit((data) => {
    console.log("Dati caricati: ", data);
    setFn(() => () => sendDataMedico(data));
    setDataToSend(data);

    if (crudOperation === "u") {
      setMessage("Vuoi aggiornare di dati di questo Medico?");
      setSeverity("warning");
    }

    if (crudOperation === "c") {
      setMessage("Confermare la registrazione di un nuovo medico?");
      setSeverity("warning");
    }

    setShowAllert(true);
  });

  const fetchPatientData = async () => {
    const objectJsonRequest: CommonFieldsData = {
      ricerca: methods.getValues("medIntDettaglio.angraficaMedici")?.trimEnd(),
      dataNascita: "",
    };

    setDataLoad(true);
    setDataFound(true);

    try {
      const objectJsonResponse = await patientResearch(objectJsonRequest);

      if (objectJsonResponse.data.dati.length < 1) {
        setDataFound(false);
      } else {
        setDataFound(true);
        setListaPazienti(objectJsonResponse.data.dati);
      }
    } catch (error) {
      console.error("Error fetching anagrafica:", error);
    } finally {
      setDataLoad(false);
    }
  };

  const tabStyle = {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    textTransform: "none",
  };

  const allertMessageProps = {
    showAllert: showAllert,
    setShowAllert: setShowAllert,
    setMessage: setMessage,
    setSeverity: setSeverity,
    severity: severity,
    message: message,
    dataToSend: dataToSend,
    setFn: setFn,
    submitFunction: fn,
  };

  return context?.fullViewAgendaForm ? (
    <>
      <MedintAgendaFormDetail
        formMethods={methods}
        fetchDataMedico={fetchDataMedico}
      />
    </>
  ) : (
    <>
      <Helmet>
        <title>Medint</title>
      </Helmet>
      <Box className="doctorContainer">
        <MedintBoxModal
          open={openBoxModal}
          onClose={() => setOpenBoxModal(false)}
          onConfirm={() => {
            setOpenBoxModal(false);
          }}
        />

        <AllertMessage
          showAllert={showAllert}
          setShowAllert={setShowAllert}
          severity={severity}
          message={message}
          dataToSend={dataToSend}
          submitFunction={fn}
        />
        <StampaAgendaModale
          methods={methods}
          showModaleStampaAgenda={showModaleStampaAgenda}
          setShowModaleStampaAgenda={setShowModaleStampaAgenda}
        />
        <NoteAggiuntiveModale
          methods={methods}
          allertMessageProps={allertMessageProps}
          showModaleNoteAggiuntive={showModaleNoteAggiuntive}
          setShowModaleNoteAggiuntive={setShowModaleNoteAggiuntive}
        />
        <Typography variant="h6">
          MEDINT - Medici Interni{" "}
          {context?.selectedDoctor
            ? `- DR. ${context.selectedDoctor.cognome} ${context.selectedDoctor.nome}`
            : ``}
        </Typography>
        {!hideDetailsActions && !context?.selectedDoctor ? (
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab value={0} label="Dettaglio" sx={tabStyle} />
          </Tabs>
        ) : hideDetailsActions ? (
          <></>
        ) : (
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab value={0} label="Dettaglio" sx={tabStyle} />
            <Tab value={1} label="Prenotazioni" sx={tabStyle} />
            <Tab
              value={2}
              label="Ricoveri / Interventi Chirurgici"
              sx={tabStyle}
            />
            <Tab value={3} label="Fatturazione" sx={tabStyle} />
          </Tabs>
        )}

        <FormProvider {...methods}>
          <form onSubmit={onSubmit}>
            {/* Se SelectedTab è uguale a 0 viene visualizzata questa schermata, altrimenti renderizza Prenotazioni (MedintBookings) */}
            {selectedTab === 0 && (
              <Paper className="doctorInfoDetails">
                <Grid container alignItems="flex-start">
                  <Grid
                    item
                    xs={12}
                    md={2}
                    display="flex"
                    justifyItems={"center"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <img
                      src={doctorImage}
                      alt="Doctor"
                      width="100vh"
                      style={{ borderRadius: "50%", marginTop: 8 }}
                    />
                  </Grid>

                  <Grid item xs={12} md={10}>
                    <Grid container rowSpacing={1} columnSpacing={2}>
                      <Grid item xs={12} md={12}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Dettaglio medico
                        </Typography>
                      </Grid>
                      {/* CODICE */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFTextField
                            control={methods.control}
                            name={"medIntDettaglio.codice"}
                            label="Codice"
                            placeholder="Inserire Codice Medico"
                            disabled={context?.selectedDoctor}
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                          />
                        ) : (
                          <TextField
                            label="Codice"
                            variant="outlined"
                            unselectable="on"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* NOMINATIVO RIDOTTO */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFTextField
                            control={methods.control}
                            name={"medIntDettaglio.nominativoRidotto"}
                            label="Nominativo Ridotto"
                            placeholder="Inserire Nominativo"
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                          />
                        ) : (
                          <TextField
                            label="Nominativo Ridotto"
                            variant="outlined"
                            disabled
                            unselectable="on"
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* ANAGRAFICA MEDICI */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <Controller
                            name="medIntDettaglio.angraficaMedici"
                            control={methods.control}
                            render={({ field }) =>
                              listaPazienti.length === 0 ? (
                                <TextField
                                  {...field}
                                  label={
                                    !dataFound
                                      ? "Nessun risultato trovato"
                                      : "Anagrafica Medici"
                                  }
                                  placeholder={
                                    "Ricerca per Cognome o Codice Fiscale"
                                  }
                                  variant="outlined"
                                  value={field.value ?? ""}
                                  fullWidth
                                  required
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      if (field.value) {
                                        fetchPatientData();
                                        methods.setValue(
                                          "medIntDettaglio.angraficaMedici",
                                          String(field.value),
                                        );
                                      }
                                    }
                                  }}
                                  size="small"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        sx={{ bgcolor: "transparent" }}
                                      >
                                        {dataLoad ? (
                                          <CircularProgress size={"1rem"} />
                                        ) : (
                                          <IconButton
                                            sx={{ height: 15, width: 15 }}
                                            onClick={(e) => {
                                              if (!field.value)
                                                e.preventDefault();
                                              else {
                                                fetchPatientData();
                                                methods.setValue(
                                                  "medIntDettaglio.angraficaMedici",
                                                  String(field.value),
                                                );
                                              }
                                            }}
                                          >
                                            <Box
                                              component="img"
                                              sx={{ height: 24, width: 24 }}
                                              src={searchIcon}
                                              alt="Ricerca Anagrafica"
                                            />
                                          </IconButton>
                                        )}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              ) : (
                                <Autocomplete
                                  autoComplete
                                  autoHighlight
                                  autoFocus
                                  open={listaPazienti.length > 0}
                                  size="small"
                                  options={listaPazienti || []}
                                  getOptionLabel={(option: any) => {
                                    if (!option) return "";
                                    return `${option.COGNOME ?? ""} ${
                                      option.NOME ?? ""
                                    }
                                `.trim();
                                  }}
                                  onChange={(_, data) => {
                                    if (data)
                                      methods.setValue(
                                        "medIntDettaglio.angraficaMedici",
                                        String(
                                          data.COGNOME.concat(" ", data.NOME),
                                        ),
                                      );
                                    setSelectedAnagrafica(data);
                                    setListaPazienti([]);
                                  }}
                                  value={
                                    field.value && field.value.trim().length > 0
                                      ? field.value
                                      : (methods.getValues(
                                          "medIntDettaglio.angraficaMedici",
                                        ) ?? null)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Anagrafica Medico"
                                      placeholder="Ricerca per Cognome o Codice Fiscale"
                                      variant="outlined"
                                      required
                                      fullWidth
                                    />
                                  )}
                                  renderOption={(props, option: any) => (
                                    <MenuItem
                                      {...props}
                                      key={option.IDPAZIENTE}
                                    >
                                      {`${option.COGNOME ?? ""} ${
                                        option.NOME ?? ""
                                      }`}
                                    </MenuItem>
                                  )}
                                />
                              )
                            }
                          />
                        ) : (
                          <TextField
                            label="Anagrafica Medici"
                            variant="outlined"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* DATA FINE RAPPORTO */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFDateTimePicker
                            dateOnly
                            name={`medIntDettaglio.dataScadenza`}
                            control={methods.control}
                            size="small"
                            fullWidth
                            label="Data Fine Rapporto"
                            displayFormat="DD/MM/YY"
                            valueFormat="YYYY-MM-DD"
                          />
                        ) : (
                          <TextField
                            label="Data Fine Rapporto"
                            variant="outlined"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* CODICE RENDICONTAZIONE */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFTextField
                            control={methods.control}
                            name={"medIntDettaglio.cfIntegrazioniMedico"}
                            label="Codice Rendicontazione PS"
                            placeholder="Inserire Codice"
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        ) : (
                          <TextField
                            label="Codice Rendicontazione PS"
                            variant="outlined"
                            disabled
                            unselectable="on"
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* SPECIALIZZAZIONE */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <Controller
                            name="medIntDettaglio.specializzazione"
                            control={methods.control}
                            render={({ field }) => (
                              <Autocomplete
                                autoComplete
                                autoHighlight
                                size="small"
                                options={listaSpecialita ?? []}
                                getOptionLabel={(option: any) => {
                                  if (!option) return "";
                                  return `${option.DESCRTIPSPL ?? ""}
                                `.trim();
                                }}
                                onChange={(_, data) => {
                                  field.onChange(data?.CODICETIPSPL ?? "");
                                }}
                                value={
                                  (listaSpecialita || []).find(
                                    (opt) => opt.CODICETIPSPL === field.value,
                                  ) || null
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.CODICETIPSPL === value?.CODICETIPSPL
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Specializzazione"
                                    placeholder="Selezionare una specializzazione"
                                    variant="outlined"
                                    fullWidth
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <MenuItem
                                    {...props}
                                    key={option.CODICETIPSPL}
                                  >
                                    {`${option.DESCRTIPSPL}`}
                                  </MenuItem>
                                )}
                                clearOnEscape
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            label="Specializzazione"
                            variant="outlined"
                            disabled
                            size="small"
                            fullWidth
                            unselectable="on"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* CODICE RFSDO */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFTextField
                            control={methods.control}
                            name={"medIntDettaglio.frsdo"}
                            label="Cod. FRSDO"
                            placeholder="Inserire Codice FRSDO"
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        ) : (
                          <TextField
                            label="Cod. RFSDO"
                            variant="outlined"
                            unselectable="on"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* PAGAMENTO ONORARIO */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <Controller
                            name="medIntDettaglio.pagamentoOnorario"
                            control={methods.control}
                            render={({ field }) => (
                              <Autocomplete
                                autoComplete
                                autoHighlight
                                size="small"
                                options={listaPagamentiOnorari ?? []}
                                getOptionLabel={(option: any) => {
                                  if (!option) return "";
                                  return `${option.DESTIPPAG ?? ""}
                                `.trim();
                                }}
                                onChange={(_, data) => {
                                  field.onChange(data?.CODTIPPAG ?? "");
                                }}
                                value={
                                  (listaPagamentiOnorari || []).find(
                                    (opt) => opt.CODTIPPAG === field.value,
                                  ) || null
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.CODTIPPAG === value?.CODTIPPAG
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Pagamento Onorario"
                                    placeholder="Selezionare un pagamento"
                                    variant="outlined"
                                    fullWidth
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <MenuItem {...props} key={option.CODTIPPAG}>
                                    {`${option.DESTIPPAG}`}
                                  </MenuItem>
                                )}
                                clearOnEscape
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            label="Pagamento Onorario"
                            variant="outlined"
                            disabled
                            size="small"
                            unselectable="on"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* MANSIONE */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <Controller
                            name="medIntDettaglio.mansione"
                            control={methods.control}
                            render={({ field }) => (
                              <Autocomplete
                                autoComplete
                                autoHighlight
                                size="small"
                                options={listaMansioni ?? []}
                                getOptionLabel={(option: any) => {
                                  if (!option) return "";
                                  return `${option.DESTIPMAN ?? ""}
                                `.trim();
                                }}
                                onChange={(_, data) => {
                                  field.onChange(data?.CODTIPMAN ?? "");
                                }}
                                value={
                                  (listaMansioni || []).find(
                                    (opt) => opt.CODTIPMAN === field.value,
                                  ) || null
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.CODTIPMAN === value?.CODTIPMAN
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Mansione"
                                    placeholder="Selezionare una mansione"
                                    variant="outlined"
                                    fullWidth
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <MenuItem {...props} key={option.CODTIPMAN}>
                                    {`${option.DESTIPMAN}`}
                                  </MenuItem>
                                )}
                                clearOnEscape
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            label="Mansione"
                            variant="outlined"
                            disabled
                            unselectable="on"
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* RITENUTA ACCONTO */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFTextField
                            control={methods.control}
                            name={"medIntDettaglio.ritenutaAcconto"}
                            label="Ritenuta d'acconto"
                            placeholder="Inserire ritenuta d'acconto"
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <PercentIcon
                                  fontSize="small"
                                  htmlColor="rgba(0, 0, 0, 0.56)"
                                />
                              ),
                            }}
                          />
                        ) : (
                          <TextField
                            label="Ritenuta d'acconto"
                            variant="outlined"
                            disabled
                            unselectable="on"
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* CODICE REFERTO PERSONALE */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <Controller
                            name="medIntDettaglio.codiceRefertoPersonale"
                            control={methods.control}
                            render={({ field }) => (
                              <Autocomplete
                                autoComplete
                                autoHighlight
                                size="small"
                                options={listaCodiciRefertiPersonali ?? []}
                                getOptionLabel={(option: any) => {
                                  if (!option) return "";
                                  return `${option.DESCR ?? ""}
                                `.trim();
                                }}
                                onChange={(_, data) => {
                                  field.onChange(data?.ID ?? "");
                                }}
                                value={
                                  (listaCodiciRefertiPersonali || []).find(
                                    (opt) => opt.ID === field.value,
                                  ) || null
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.ID === value?.ID
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Codice Referto Personale"
                                    placeholder="Inserire Codice personale"
                                    variant="outlined"
                                    fullWidth
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <MenuItem {...props} key={option.ID}>
                                    {`${option.DESCR}`}
                                  </MenuItem>
                                )}
                                clearOnEscape
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            label="Codice Referto Personale"
                            variant="outlined"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* RADIO BUTTONS  */}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        <FormControl>
                          <RadioGroup
                            defaultValue="Totale"
                            name="radio-buttons-group"
                            row
                          >
                            <Controller
                              name="medIntDettaglio.tipoServizio"
                              control={methods.control}
                              render={() => (
                                <>
                                  <FormControlLabel
                                    value="Totale"
                                    control={<Radio />}
                                    disabled={dataLoadMedico}
                                    label="Totale"
                                    onChange={() =>
                                      methods.setValue(
                                        "medIntDettaglio.tipoServizio",
                                        "T",
                                      )
                                    }
                                  />
                                  <FormControlLabel
                                    value="Ambulatori"
                                    control={<Radio />}
                                    // disabled={disabled}
                                    label="Ambulatori"
                                    onChange={() =>
                                      methods.setValue(
                                        "medIntDettaglio.tipoServizio",
                                        "A",
                                      )
                                    }
                                  />
                                  <FormControlLabel
                                    value="Ricoveri"
                                    control={<Radio />}
                                    label="Ricoveri"
                                    onChange={() =>
                                      methods.setValue(
                                        "medIntDettaglio.tipoServizio",
                                        "R",
                                      )
                                    }
                                  />
                                </>
                              )}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {/* VALIDITA' AGENDA */}
                      <Grid item xs={12} md={6}>
                        {!dataLoadMedico ? (
                          <RHFDateTimePicker
                            dateOnly
                            name={`medIntDettaglio.validitaAgenda`}
                            control={methods.control}
                            size="small"
                            fullWidth
                            label="Validità Agenda"
                            displayFormat="DD/MM/YY"
                            valueFormat="YYYY-MM-DD"
                          />
                        ) : (
                          <TextField
                            label="Validità Agenda"
                            variant="outlined"
                            disabled
                            size="small"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{ bgcolor: "transparent", gap: 2 }}
                                >
                                  <CircularProgress size={"1rem"} />
                                  {` Caricamento.. `}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Grid>
                      {/* CHECKBOX PLANNING */}
                      <Grid item xs={12} md={6}>
                        <RHFCheckbox
                          label={"Abilita planning prenotazione interventi"}
                          control={methods.control}
                          name={"medIntDettaglio.planning"}
                        />
                      </Grid>
                      <Grid item xs={0} md={6} />
                      {/* CHECKBOX EQUIPE */}
                      <Grid item xs={12} md={6}>
                        <RHFCheckbox
                          label={"Equipe"}
                          control={methods.control}
                          name={"medIntDettaglio.equipe"}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            )}

            {selectedTab === 1 && (
              <MedintBookings
                methods={methods}
                allertMessageProps={allertMessageProps}
                fetchDataMedico={fetchDataMedico}
                setHideDetailsActions={setHideDetailsActions}
              />
            )}

            {selectedTab === 2 && (
              <>
                <FormRicoveri
                  methods={methods}
                  allertMessageProps={allertMessageProps}
                  fetchDataMedico={fetchDataMedico}
                />
              </>
            )}

            {selectedTab === 3 && (
              <>
                <FormFatturazione methods={methods} />
              </>
            )}

            {selectedTab >= 0 && !hideDetailsActions ? (
              <Box
                display="flex"
                justifyContent="space-between"
                width="100%"
                mt={2}
              >
                <Button
                  variant="outlinedError"
                  color="error"
                  onClick={() => handleExitClick()}
                >
                  Uscita
                </Button>
                {context?.selectedDoctor && !hideDetailsActions && (
                  <Box
                    display={"Flex"}
                    justifyContent={"center"}
                    width={"100%"}
                    gap={2}
                  >
                    <Button
                      variant="outlinedCustom"
                      color="primary"
                      onClick={() => {
                        setShowModaleStampaAgenda(true);
                      }}
                    >
                      Agenda
                    </Button>
                    <Button
                      variant="outlinedCustom"
                      color="primary"
                      onClick={() => {
                        setShowModaleNoteAggiuntive(true);
                      }}
                    >
                      Note Aggiuntive
                    </Button>
                    <Button
                      variant="outlinedCustom"
                      color="primary"
                      onClick={() => setOpenBoxModal(true)}
                    >
                      Box
                    </Button>

                    <Button variant="outlinedCustom" color="primary">
                      Coll GP
                    </Button>
                    <Button variant="outlinedCustom" color="primary">
                      Servizio Filavia
                    </Button>
                  </Box>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  className="confirmButton"
                  type="submit"
                >
                  Conferma
                </Button>
              </Box>
            ) : null}
          </form>
        </FormProvider>
      </Box>
    </>
  );
};

export default MedintDetails;
